import React from 'react';
import { Select } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import './index.scss';

export default function SingleSelectFilter(props: {
  options: Array<{ text: string; value: string }>;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  placeholder?: string;
  matchButtonWidth?: boolean;
}) {
  const { options, value = '', onChange, className, placeholder, matchButtonWidth = true } = props;
  const { formatMessage, formatOptionsMessage } = useLanguage();

  return (
    <Select
      className={`dbo-single-select ${className ? className : ''}`}
      appearance="button"
      options={formatOptionsMessage(options)}
      value={value}
      matchButtonWidth={matchButtonWidth}
      onChange={(value) => {
        onChange?.(value);
      }}
      button={(option) => {
        const selectedOption = options.find((o) => o.value === value);
        const displayText = selectedOption?.text || value;

        return (
          <div className="dbo-select-button">
            <span className="dbo-select-button-text">
              {placeholder && <span className="dbo-select-button-placeholder">{placeholder} </span>}
              <span className="dbo-select-button-value">{displayText}</span>
            </span>
          </div>
        );
      }}
    />
  );
}
